import { useEffect, useState } from "react";

const useClipboardPaste = (onPasteImage: (e:any, file?: File) => void) => {
  useEffect(() => {
    const handlePaste = (event: ClipboardEvent) => {                     
      if (!event.clipboardData)
      { 
        onPasteImage(event,undefined);
        return;      
      } 
     
      let handled = false;
      const items = Array.from(event.clipboardData.items);     
      for (const item of items) {
        if (item.type.startsWith("image/")) {
          const file = item.getAsFile();
          if (file) {            
            onPasteImage(event,file);
            handled = true;
            break; //To break the loop once the first image is found
          }
        }
      }

      if (!handled) {
        onPasteImage(event,undefined);
      }
    };

    document.addEventListener("paste", handlePaste);
    return () => document.removeEventListener("paste", handlePaste);
  }, [onPasteImage]);
};


const useClipboardNotification = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleClipboardEvent = () => {
      setVisible(true);
      setTimeout(() => setVisible(false), 3000);
    };

    document.addEventListener("copy", handleClipboardEvent);
    document.addEventListener("paste", handleClipboardEvent);

    return () => {
      document.removeEventListener("copy", handleClipboardEvent);
      document.removeEventListener("paste", handleClipboardEvent);
    };
  }, []);

  return [visible, setVisible] as const;
};


const areFilesSame=(file1:File, file2:File)=> {
  return (
    file1.name === file2.name &&
    file1.size === file2.size &&
    file1.type === file2.type &&
    file1.lastModified === file2.lastModified
  );
}


const getLastImageFromClipboardAsFile = async () => {
  try {
    
    const items = await navigator.clipboard.read();    
    for (const item of items) {
      const imageType = item.types.find(type => type.startsWith('image/'));
      if (imageType) {
        const blob = await item.getType(imageType);
        const file = new File([blob], 'clipboard-image', { type: imageType });
        //console.log("Image File:", file);
        return file; // Return the file object
      }
    }
    console.log("No image found in clipboard");
  } catch (err) {
    console.error("Failed to read clipboard contents: ", err);    
  }
};

export { useClipboardPaste, useClipboardNotification, areFilesSame, getLastImageFromClipboardAsFile };
